import { c as _c } from "react/compiler-runtime";
import { CarouselDots } from "@website/ui/carousel/carousel-dots";
import { CarouselNavigation } from "@website/ui/carousel/carousel-navigation";
import { CarouselPropertiesType } from "@website/ui/carousel/carousel.types";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { FC, useState } from "react";
export const CarouselV2: FC<CarouselPropertiesType> = t0 => {
  const $ = _c(29);
  const {
    sectionClassName: t1,
    options,
    list,
    keyCarousel,
    hasNavigation: t2,
    itemClass,
    hasDots,
    mode,
    rightBtnClassName,
    leftBtnClassName,
    disableArrowKeys
  } = t0;
  const sectionClassName = t1 === undefined ? "" : t1;
  const hasNavigation = t2 === undefined ? true : t2;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  let t3;
  if ($[0] !== mode || $[1] !== options) {
    t3 = {
      initial: 0,
      rtl: true,
      renderMode: "performance",
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      ...options,
      mode
    };
    $[0] = mode;
    $[1] = options;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [sliderReference, instanceReference] = useKeenSlider(t3);
  const t4 = `keen-slider size-full ${sectionClassName}`;
  let t5;
  if ($[3] !== itemClass || $[4] !== keyCarousel || $[5] !== list) {
    t5 = list?.map((component, index) => <article className={`keen-slider__slide ${itemClass} !overflow-visible`} key={`${keyCarousel}-slide-${index++}`}>{component}</article>);
    $[3] = itemClass;
    $[4] = keyCarousel;
    $[5] = list;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== sliderReference || $[8] !== t4 || $[9] !== t5) {
    t6 = <section className={t4} ref={sliderReference}>{t5}</section>;
    $[7] = sliderReference;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== currentSlide || $[12] !== disableArrowKeys || $[13] !== hasNavigation || $[14] !== instanceReference || $[15] !== leftBtnClassName || $[16] !== loaded || $[17] !== rightBtnClassName) {
    t7 = Boolean(hasNavigation) && loaded && instanceReference?.current && <CarouselNavigation currentReference={instanceReference.current} currentSlide={currentSlide} disableArrowKeys={disableArrowKeys} hasNavigation={hasNavigation} leftBtnClassName={leftBtnClassName} rightBtnClassName={rightBtnClassName} />;
    $[11] = currentSlide;
    $[12] = disableArrowKeys;
    $[13] = hasNavigation;
    $[14] = instanceReference;
    $[15] = leftBtnClassName;
    $[16] = loaded;
    $[17] = rightBtnClassName;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== currentSlide || $[20] !== hasDots || $[21] !== instanceReference || $[22] !== keyCarousel || $[23] !== loaded) {
    t8 = Boolean(hasDots) && loaded && instanceReference?.current && <CarouselDots currentReference={instanceReference.current} currentSlide={currentSlide} keyCarousel={keyCarousel} />;
    $[19] = currentSlide;
    $[20] = hasDots;
    $[21] = instanceReference;
    $[22] = keyCarousel;
    $[23] = loaded;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = <article className="group relative size-full">{t6}{t7}{t8}</article>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};